import { get } from 'lodash'

export default function(fields = {}, { photoUrl = false, localeId }) {
  const data = {
    id: fields.id,
    title: fields.title,
    firstName: fields.firstName,
    middleName: fields.middleName,
    lastName: fields.lastName,
    gender: fields.gender,
    nationality: fields.nationality,
    employmentStatus: fields.employmentStatus,
    birthDate: fields.birthDate,
    email: fields.email,
    userName: fields.userName,
    locale: {
      id: localeId
    },
    userAccountId: fields.userAccountId,
    organizationMember: fields.organizationMember,
    awardLeader: fields.awardLeader,
    phone: get(fields, 'phone'),
    participantDetail: {
      note: get(fields, 'note'),
      previousCompletedAwardLevel: get(
        fields,
        'participantDetail.previousCompletedAwardLevel'
      ),
      previousCompletedAwardPlace: get(
        fields,
        'participantDetail.previousCompletedAwardPlace'
      ),
      isGivenConsentForPhotoUse: get(
        fields,
        'participantDetail.isGivenConsentForPhotoUse'
      )
    },
    phoneType: {
      value: get(fields, 'phoneType.value')
    },
    secondaryPhone: fields.secondaryPhone,
    secondaryEmail: fields.secondaryEmail,
    secondaryPhoneType: {
      value: get(fields, 'secondaryPhoneType.value')
    },
    address: {
      id: get(fields, 'address.id'),
      line1: get(fields, 'address.line1'),
      line2: get(fields, 'address.line2'),
      city: get(fields, 'address.city'),
      stateOrProvinceOrRegion: get(fields, 'address.stateOrProvinceOrRegion'),
      zipCode: get(fields, 'address.zipCode'),
      country: {
        id: get(fields, 'address.country.id')
      }
    },
    postalAddress: get(fields, 'postalAddress'),
    photoUrl: photoUrl || get(fields, 'photoUrl'),
    userRegistrationAssessmentState: fields.userRegistrationAssessmentState,
    parentFirstName: fields.parentFirstName,
    parentLastName: fields.parentLastName,
    parentPhone: fields.parentPhone,
    parentEmail: fields.parentEmail,
    parentRelationship: fields.parentRelationship,
    consentDeliveryType: fields.consentDeliveryType,
    personState: fields.personState,
    previousCompletedAwardLevel: {
      id: get(fields, 'previousCompletedAwardLevel.id')
    },
    state: fields.state,
    awardLevel: {
      id: get(fields, 'awardLevel.id')
    },
    isAddActivityLogAllowed: get(fields, 'isAddActivityLogAllowed')
  }

  if (!get(fields, 'awardLevel.id')) {
    data.awardLevel = undefined
  }

  // if (get(fields, 'awards')) {
  //   data.awards = []

  //   fields.awards.forEach((item, index) => {
  //     data.awards[index] = {
  //       creationDate: item.creationDate,
  //       paymentState: {
  //         value: get(item, 'paymentState.value')
  //       },
  //       paymentDate: get(item, 'paymentDate'),
  //       isPaymentConfirmed: get(item, 'isPaymentConfirmed'),
  //       consentDeliveryDate: get(item, 'consentDeliveryDate'),
  //       isConsentDeliveryConfirmed: get(item, 'isConsentDeliveryConfirmed'),
  //       consentDeliveryType: {
  //         value: get(item, 'consentDeliveryType.value')
  //       },
  //       participantRegistration: {
  //         parentRelationship: get(item, 'participantRegistration.parentRelationship'),
  //         parentFirstName: get(item, 'participantRegistration.parentFirstName'),
  //         parentLastName: get(item, 'participantRegistration.parentLastName'),
  //         parentEmail: get(item, 'participantRegistration.parentEmail'),
  //         parentPhone: get(item, 'participantRegistration.parentPhone'),
  //       }
  //     }
  //   })
  // }

  return data
}
